import styles from "./status.module.css";
import { CLOSED_STATUS } from "../../constants";
import classNames from "classnames";
import Pill from "../../../common/Pill";

export function ClosedStatus() {
  return (
    <Pill
      styleName="resolve"
      Lefticon={<img src={"../../../assets/images/svg/judge.svg"} />}>
      <p className={classNames(styles.text, "p2")}>{CLOSED_STATUS}</p>
    </Pill>
  );
}
